/**
 * @module IDEE/style/state
 */

/**
 * Estado de estilo predeterminado.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const DEFAULT = 'default';

/**
 * Estado del nuevo estilo.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const NEW = 'new';

/**
 * Estado del estilo seleccionado.
 * @const
 * @type {string}
 * @public
 * @api
 */
export const SELECTED = 'selected';
